import * as React from "react";
import Layout from "../components/layout";
import InternationalContent from "../components/enrolment/internationalContent";
import BannerImage from "../components/master/BannerImage";
import heroImage from "../assets/enrolment/enrolment-hero-image.jpg";

const InternationalPage = () => {
  return (
    <Layout>
      <BannerImage imagePath={heroImage} altText="..." />
      <InternationalContent />
    </Layout>
  );
};

export default InternationalPage;
